module.exports = __webpack_public_path__ + "img/horizontal_7_3_9005.5e42f3cc.png";